import RendimientoProfesionalismoDto from '../domain/RendimientoProfesionalismoDto'

export default class UpdateRendimientoProfesionalismo {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(rendimientoProfesionalismo) {
    const payload = RendimientoProfesionalismoDto.update(rendimientoProfesionalismo)

    await this.#repository.update(payload, rendimientoProfesionalismo.detalle.idEvaluado, rendimientoProfesionalismo.id)
    await this.#repository.updateEstatus(
      { fk_idCatEstatusEvaluacion: payload.fk_idCatEstatusEvaluacion },
      rendimientoProfesionalismo.detalle.idEvaluado,
      rendimientoProfesionalismo.id
    )
  }
}
